import { Component, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseConfirmationDialogComponent } from '../../lib/components/dialogs/base-confirmation-dialog.component';
import { ReferenceDataLabels } from '../../lib/constants/reference-data-labels';
import { Address } from '../../lib/models/api/address.model';
import { AddressesService } from '../../lib/services/addresses.service';

@Component({
  selector: 'boi-postal-address-finder',
  templateUrl: './postal-address-finder.component.html',
  styleUrls: ['./postal-address-finder.component.scss']
})
export class PostalAddressFinderComponent extends BaseConfirmationDialogComponent<string> implements OnChanges {
  @Output() public readonly addressSelected = new EventEmitter<Address>();
  @Output() public readonly isPostCodeInvalid = new EventEmitter<boolean>();
  public referenceDataLabels = ReferenceDataLabels;
  public addresses: Array<Address> = [];
  public selected: Address;

  constructor(private readonly addressesService: AddressesService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.opened && changes.opened.currentValue && this.data) {
      this.opened = false;
      this.openDialog();
    }
  }

  public select(address: Address): void {
    this.selected = address;
  }

  public confirm(): void {
    this.addressSelected.emit(this.selected);
    this.close();
  }

  private openDialog(): void {
    this.addressesService
      .getAddresses(this.data)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(
        (addresses) => {
          this.addresses = addresses;
          this.opened = true;
          this.isPostCodeInvalid.emit(false);
        },
        (_error) => {
          this.openedChange.emit(this.opened);
          this.isPostCodeInvalid.emit(true);
        }
      );
  }
}
